// BANDEIRAS EM SVG.
//
// Emoji de bandeira NAO funciona no Windows: o sistema nao tem a fonte, e o
// navegador cai no par de letras -- "US", "BR". Foi exatamente isso que
// apareceu na tela. Em SVG a bandeira e a mesma em qualquer aparelho, e some o
// risco de a interface mudar de cara conforme o sistema de quem joga.

import React from 'react';

const FLAGS = {
  BR: (
    <>
      <rect width="28" height="20" fill="#009b3a" />
      <path d="M14 2.2 25.4 10 14 17.8 2.6 10Z" fill="#fedf00" />
      <circle cx="14" cy="10" r="4.1" fill="#002776" />
      <path d="M10.2 8.7a8 8 0 0 1 7.7 2.2" stroke="#fff" strokeWidth="1.15" fill="none" />
    </>
  ),
  US: (
    <>
      <rect width="28" height="20" fill="#fff" />
      {[0, 2, 4, 6, 8, 10, 12].map((i) => (
        <rect key={i} y={i * 1.538} width="28" height="1.538" fill="#b22234" />
      ))}
      <rect width="12" height="10.77" fill="#3c3b6e" />
      {[1.6, 4.4, 7.2, 9.6].map((y) => (
        [1.4, 3.8, 6.2, 8.6, 10.6].map((x) => (
          <circle key={`${x}-${y}`} cx={x} cy={y} r=".62" fill="#fff" />
        ))
      ))}
    </>
  ),
  EU: (
    <>
      <rect width="28" height="20" fill="#003399" />
      {Array.from({ length: 12 }).map((_, i) => {
        const ang = (i * Math.PI) / 6 - Math.PI / 2;
        return (
          <circle
            key={i}
            cx={14 + Math.cos(ang) * 5.6}
            cy={10 + Math.sin(ang) * 5.6}
            r=".9"
            fill="#ffcc00"
          />
        );
      })}
    </>
  ),
};

/** Bandeira. `code` e BR, US ou EU. */
export function Flag({ code = 'BR', size = 18, title }) {
  const art = FLAGS[code] || FLAGS.EU;
  const h = Math.round((size * 20) / 28);
  return (
    <svg
      className="flag"
      width={size}
      height={h}
      viewBox="0 0 28 20"
      role={title ? 'img' : 'presentation'}
      aria-label={title || undefined}
    >
      {art}
    </svg>
  );
}

export const NATION_LABEL = {
  BR: 'Brasil',
  US: 'Estados Unidos',
  EU: 'Europa',
};
